import styled from 'styled-components';
import CTA from '../../atoms/CTA';
import ExtendedGridWrapper from '../../organisms/ExtendedGridWrapper';
import { CTAIconPosition } from '../../atoms/CTA/CTA.constants';

const Wrapper = styled.div`
  width: 100%;
`;

/**
 * @param {LinkListProps} props
 * @returns {React.ReactElement} The rendered component
 */
const LinkList = ({ links, extendedGrid, isBrand }) => {
  const content = links.map((link, idx) => {
    const { title, text, href, target, icon } = link;
    return (
      <div key={idx}>
        <CTA
          skin="TERTIARY"
          iconPos={CTAIconPosition.Before}
          {...{
            title,
            text,
            href,
            target,
            icon,
            isBrand,
          }}
        />
      </div>
    );
  });

  if (extendedGrid) {
    return <ExtendedGridWrapper>{content}</ExtendedGridWrapper>;
  }
  return <Wrapper>{content}</Wrapper>;
};

export default LinkList;
